<script>
  export let absolute = false;
  export let dark = false; // dark variant for slate-900 sections
</script>

<footer class="{absolute ? 'absolute w-full bottom-0' : 'relative'} {dark ? 'border-t border-slate-800' : 'border-t border-line bg-surface'} py-6">
  <div class="max-w-6xl mx-auto px-4 md:px-8 flex flex-wrap items-center justify-between gap-3">
    <p class="text-xs {dark ? 'text-slate-500' : 'text-ink-tertiary'}">
      © {new Date().getFullYear()}
      <a href="/" class="font-medium {dark ? 'text-slate-300 hover:text-white' : 'text-ink-secondary hover:text-ink'}">
        Moira Finance
      </a>
    </p>
    <ul class="flex flex-wrap items-center gap-5">
      <li>
        <a href="/terms" class="text-xs {dark ? 'text-slate-400 hover:text-white' : 'text-ink-secondary hover:text-ink'}">
          Terms of Service
        </a>
      </li>
      <li>
        <a href="/privacy" class="text-xs {dark ? 'text-slate-400 hover:text-white' : 'text-ink-secondary hover:text-ink'}">
          Privacy Policy
        </a>
      </li>
      <li>
        <a href="mailto:support@moirafinance.com" class="text-xs {dark ? 'text-slate-400 hover:text-white' : 'text-ink-secondary hover:text-ink'}">
          Contact
        </a>
      </li>
    </ul>
  </div>
</footer>
